import { connect } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import PropertyPickerVertical from './components/PropertyPickerVertical';
import BaseFeature from './BaseFeature';
import { MULTIPLE_OUTPUT_CURRENT } from '../../../../../../utils/constantFeatures';

class MultipleOutputCurrent extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {

        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {

        const v = value;

        this.props.handleChange(propertyName, v);
    }

    render() {

        const channel1 = this.props.properties[MULTIPLE_OUTPUT_CURRENT.channel1];
        const channel2 = this.props.properties[MULTIPLE_OUTPUT_CURRENT.channel2];

        return (
            <div>
                <div className="flex-row">
                    <Card className={this.getClassName([channel1])}>
                        <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                            {'Channel 1'}
                        </div>
                        <Card.Body style={{ display: "flex" }}>
                            <Col className="card-body-feature-col" style={{ paddingLeft: "0" }}>
                                <Row style={{ fontWeight: "500" }}>
                                    {'Minimum Current'}
                                </Row>
                                <Row className="value-current-setting">
                                    {channel1.valueMeta.min}
                                </Row>
                                <Row className="unit-measure-current-setting">
                                    {'mA'}
                                </Row>
                            </Col>
                            <PropertyPickerVertical
                                property={channel1}
                                title={'Operating Current'}
                                measureUnit={'mA'}
                                min={channel1.valueMeta.min}
                                max={channel1.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <Col className="card-body-feature-col" style={{ paddingRight: "0" }}>
                                <Row style={{ fontWeight: "500" }}>
                                    {'Maximum Current'}
                                </Row>
                                <Row className="value-current-setting">
                                    {channel1.valueMeta.max}
                                </Row>
                                <Row className="unit-measure-current-setting">
                                    {'mA'}
                                </Row>
                            </Col>
                        </Card.Body>
                    </Card>
                </div>
                <div className="flex-row" style={{ paddingTop: '0.75rem' }}>
                    <Card className={this.getClassName([channel2])}>
                        <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                            {'Channel 2'}
                        </div>
                        <Card.Body style={{ display: "flex" }}>
                            <Col className="card-body-feature-col" style={{ paddingLeft: "0" }}>
                                <Row style={{ fontWeight: "500" }}>
                                    {'Minimum Current'}
                                </Row>
                                <Row className="value-current-setting">
                                    {channel2.valueMeta.min}
                                </Row>
                                <Row className="unit-measure-current-setting">
                                    {'mA'}
                                </Row>
                            </Col>
                            <PropertyPickerVertical
                                property={channel2}
                                title={'Operating Current'}
                                measureUnit={'mA'}
                                min={channel2.valueMeta.min}
                                max={channel2.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <Col className="card-body-feature-col" style={{ paddingRight: "0" }}>
                                <Row style={{ fontWeight: "500" }}>
                                    {'Maximum Current'}
                                </Row>
                                <Row className="value-current-setting">
                                    {channel2.valueMeta.max}
                                </Row>
                                <Row className="unit-measure-current-setting">
                                    {'mA'}
                                </Row>
                            </Col>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MultipleOutputCurrent);
